import { render } from "./MandatoryIcon.vue?vue&type=template&id=3e2ef88a&scoped=true"
const script = {}

import "./MandatoryIcon.vue?vue&type=style&index=0&id=3e2ef88a&scoped=true&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\HAVELI\\havelidashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2ef88a"]])

export default __exports__